import login from './login';
import signUp from './signup';
import edit from './edit';
import loginAnonymous from './loginAnonymous';
import detail from './detail';
import requestPassword from './requestPassword';

export { signUp, loginAnonymous, detail, requestPassword, edit };
export default login;
